(function() {


	// constructor:
	/**
	 * Extended Container that will align it's coordinates (x, y) based on the provided percentages using the canvas' width and height properties.
	 * This is useful for anchoring certain
	 * <h4>Example</h4>
	 * 
	 *      var point = new createjs.Point(0, 100);
	 * 
	 * @class Point
	 * @param {Number} [x=0] X position.
	 * @param {Number} [y=0] Y position.
	 * @constructor
	 **/

	function Layer( name, xPercent, yPercent )
	{
		this.Container_constructor();

		this.name = name;
		this.px = xPercent;
		this.py = yPercent;

		Layer.s[name] = this;
	}

	var p = createjs.extend(Layer, cjs.Container);

	Layer.s = {};
	Layer.alignLayers = function(w, h)
	{
		var pt = new cjs.Point();

		for ( var key in Layer.s)
		{
			var layer = Layer.s[key];
			if(layer.parent && layer.px && layer.py)
			{
				var tx = w * layer.px;
				var ty = h * layer.py;

				layer.parent.globalToLocal(tx, ty, pt);

				layer.x = pt.x;
				layer.y = pt.y;
			}
		}
	};

	p.destroy = function()
	{
		delete Layer.s[this.name];
	};

	cm.Layer = cjs.promote(Layer, "Container");
})();